import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Upload from './Upload';
import ImageDelete from './ImageDelete';
import routes from './routes'
const { upload, inspect } = routes;

function Uploads() {
  return (
    <Routes>
      <Route path={upload} element={<Upload />} />
      <Route path={inspect} element={<ImageDelete />} />
      <Route path='*' element={<Navigate to={upload} />} />
    </Routes>
  );
}

export default Uploads;
